import React, { useEffect, useState } from 'react'
import $ from 'jquery'
import { useNavigate, useLocation } from 'react-router-dom';

export default function Logout() {
  const navigate = useNavigate();
    useEffect(()=>{
        
         localStorage.setItem('member_id', 'n/a');
            localStorage.setItem('memberFirstname', 'n/a');
            localStorage.setItem('membername', 'n/a');
            localStorage.setItem('useremail', 'n/a');
            localStorage.setItem('mem_permission', 'n/a');
            localStorage.setItem('user_position', 'n/a');
            localStorage.setItem('mem_company_name', 'n/a');
            localStorage.setItem('mem_company_id', 'n/a');
            navigate('/');
    });
  return (
    <div>
      
    </div>
  )
}
